import { createApp } from 'vue'
import CommentsApp from './App.vue'

/**
 * 评论组件入口
 * Islands 架构 - 独立的 Vue 应用，挂载到服务端渲染的页面中
 */

const el = document.getElementById('comments-app')
if (el) {
  const app = createApp(CommentsApp, {
    riddleId: el.dataset.riddleId || '',
    tenantId: el.dataset.tenantId || '0',
    userLoggedIn: el.dataset.userLoggedIn === 'true',
    userId: el.dataset.userId || '',
    userName: el.dataset.userName || '',
    userAvatar: el.dataset.userAvatar || '/static/img/default-avatar.png',
  })

  app.mount(el)
}
